import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header.jsx';
import Footer from './components/Footer.jsx';
import ScrollToTop from './components/ScrollToTop.jsx';
import AccessibilityWidget from './components/AccessibilityWidget.jsx';
import CookieBanner from './components/CookieBanner.jsx';
import Home from './routes/Home.jsx';
import About from './routes/About.jsx';
import Contact from './routes/Contact.jsx';
import ServicesIndex from './routes/ServicesIndex.jsx';
import ServicePage from './routes/ServicePage.jsx';
import BlogIndex from './routes/BlogIndex.jsx';
import BlogPost from './routes/BlogPost.jsx';
import Cases from './routes/Cases.jsx';
import NotFound from './routes/NotFound.jsx';
import Privacy from './routes/Privacy.jsx';
import Terms from './routes/Terms.jsx';

const AdminInbox = lazy(() => import('./routes/AdminInbox.jsx'));

import './styles/tokens.css';
import './styles/app.css';

function AppShell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  if (isAdmin) {
    return (
      <Suspense fallback={null}>
        <Routes>
          <Route path="/admin/inbox" element={<AdminInbox />} />
          <Route path="/admin/*" element={<AdminInbox />} />
        </Routes>
      </Suspense>
    );
  }

  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<ServicesIndex />} />
        <Route path="/services/:slug" element={<ServicePage />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        {/* Linked from the footer on every page and listed in sitemap.xml and
            llms.txt, with no route behind it — so it fell through to NotFound. */}
        <Route path="/cases" element={<Cases />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      <AccessibilityWidget />
      <CookieBanner />
    </>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </HelmetProvider>
  );
}
